import React, { useState, useEffect } from 'react'
import {
    Collapse,
    Row,
    Col,
    Button,
    Form,
    Input,
    Select,
    DatePicker,
    notification,
    Spin,
    Modal
} from "antd";
import { SUCCESS_STATUS } from '../../utility/Constants'

import { CaretRightOutlined, RightOutlined, SearchOutlined } from "@ant-design/icons";
import ProgrammeService from '../../api/programme.service';
import WaiveViewList from './WaiveViewList';
import CustomTableSearch from '../../components/common/CustomTableSearch'
import moment from 'moment';
import { PRINT_BASE_URL } from "../../utility/URL";
import commonUtility from "../../utility/Utils";

const { Option } = Select;


const defaultFormValues = {
    programme_group_id: "",
    programme_id: "",

};

const WaiveListView = () => {
    const [form] = Form.useForm();
    const [programmeList, setProgrammeList] = useState([]);
    const [programmeGroupList, setProgrammeGroupList] = useState([]);
    const [waiveViewList, setWaiveViewList] = useState([]);
    const [loading, setLoading] = useState(false);

    console.log("waiveViewListtt", waiveViewList)

    useEffect(() => {
        ProgrammeService.programmeList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeList(res.data.response_data);
            }
        });

    }, []);

    useEffect(() => {
        ProgrammeService.programmeGroupList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeGroupList(res.data.response_data);
            }
        });
    }, []);



    const onFinish = (values) => {
        console.log("Original Form Values:", values);
        setLoading(true);
        const formattedValues = {
            formdata: {
                programme_id: values.programme_id,
                from_date: values.fromDate ? moment(values.fromDate).format('DD/MM/YYYY') : '',
                to_date: values.toDate ? moment(values.toDate).format('DD/MM/YYYY') : '',
                programme_group_id: values.group_id || 0,
            },
        };
        console.log("Formatted Form Data:", formattedValues);

        // Assuming the API now expects a POST request
        ProgrammeService.getWaiveList(formattedValues)
            .then((res) => {
                setLoading(false);
                if (res.data.response_status === SUCCESS_STATUS) {
                    if (res.data.response_data && res.data.response_data.length > 0) {
                        setWaiveViewList(res.data.response_data);
                    } else {
                        notification.info({
                            message: 'No Data Found',
                            description: 'No data found for the selected criteria.',
                        });
                    }
                } else {
                    notification.error({
                        message: 'Error',
                        description: res.data.response_msg,
                    });
                }
            })
            .catch(() => {
                setLoading(false);
                notification.error({
                    message: 'Error',
                    description: 'Failed to fetch data.',
                });
            });
    };


    const buildExcelUrl = (values, url_first) => {
        let url = '';
        console.log(values);
        const formValues = {
            from_date: formatDate(values.fromDate ? moment(values.fromDate).format('DD/MM/YYYY') : '') || '',
            to_date: formatDate(values.toDate ? moment(values.toDate).format('DD/MM/YYYY') : '') || '',
            programme_id: values.programme_id || '0',
            programme_group_id: values.group_id || '0'
        };

        if (formValues.from_date !== "" && formValues.to_date !== "") {
            url = `${PRINT_BASE_URL}${url_first}/${formValues.from_date}/${formValues.to_date}/${formValues.programme_id}/${formValues.programme_group_id}`;
        }
        return url;
    };

    const formatDate = (dateStr) => {
        return dateStr ? dateStr.replace(/\//g, '-') : '';
    };

    const handlePdfDownload = async () => {
        try {
            const values = await form.validateFields();
            const url_excel = 'gstregister/waive_list_pdf';
            let url = buildExcelUrl(values, url_excel);
            commonUtility.openInNewTab(url);
        } catch (error) {
            console.error('Error generating Excel report:', error);
        }
    };

    return (
        <>
            <div className="form-input-style">
                <Row className="login-first-step-row" style={{ background: "#f4f4f4" }}>
                    <Col className="form-format-type1 enrollment-form jcp-enrollment" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            autoComplete="off"
                            initialValues={defaultFormValues}
                            onFinish={onFinish}
                        >
                            <Row gutter={20}>
                                <Col xs={24} xl={24}>
                                    <Row gutter={20}>
                                        <Col xs={4} xl={6} style={{ margin: "0.5rem" }}>
                                            <Form.Item
                                                name="programme_id"
                                                label="Programme"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Select Programme",
                                                    },
                                                ]}
                                            >
                                                <Select className="text-left"
                                                    placeholder="Select Programme"
                                                >
                                                    <Option value="">Select</Option>
                                                    {programmeList.length > 0
                                                        ? programmeList.map((programme_list) => (
                                                            <Option
                                                                key={programme_list.programme_id}
                                                                value={programme_list.programme_id}
                                                                short_code={programme_list.short_code}
                                                            >
                                                                {programme_list.programme_name}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                            <Form.Item
                                                name="fromDate"
                                                label="From Date"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Select From Date",
                                                    },
                                                ]}
                                            >
                                                <DatePicker style={{ width: "100%" }} placeholder="Select From Date" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                            <Form.Item
                                                name="toDate"
                                                label="To Date"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Select To Date",
                                                    },
                                                ]}
                                            >
                                                <DatePicker style={{ width: "100%" }} placeholder="Select To Date" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={6} xl={4} style={{ margin: "0.5rem" }}>
                                            <Form.Item
                                                name="group_id"
                                                label="Shift(Optional)"
                                            >
                                                <Select
                                                    className="text-left"
                                                    placeholder="Select Shift"
                                                >
                                                    <Option value="">Select</Option>
                                                    {programmeGroupList.length > 0
                                                        ? programmeGroupList.map((programme_group_list) => (
                                                            <Option
                                                                key={programme_group_list.programme_group_id}
                                                                value={programme_group_list.programme_group_id}
                                                            >
                                                                {programme_group_list.programme_group}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={2} xl={2} style={{ margin: "0.5rem" }}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="submit"
                                                    shape="round"
                                                    loading={loading}
                                                    className="custom-button-green"
                                                >
                                                    <SearchOutlined />
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                         <Col xs={2} xl={2} style={{ marginTop: "8px", marginLeft: "-40px" }}>
                                            <Form.Item label=" ">
                                               <Button
                                                    htmlType="submit"
                                                    shape="round"
                                                    className="custom-button-green"
                                                    style={{ marginLeft: '10px' }}
                                                    onClick={handlePdfDownload}
                                                >
                                                    PDF
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </div>
            <div className='tableView'>
                <div className="form-content">
                    <WaiveViewList waiveViewList={waiveViewList} />
                </div>
            </div>
        </>
    )
}

export default WaiveListView;
